module.exports = __webpack_public_path__ + "static/img/4-1.89f06f05.png";